import SlideInWrapper from 'components/SlideInWrapper'
import LiveChatIntegration from 'components/integrations/livechat/LiveChatIntegration'
import useSectionOpenedTracking from 'hooks/useSectionOpenedTracking'

function LiveChat() {
	useSectionOpenedTracking()

	return (
		<SlideInWrapper>
			<LiveChatIntegration />
		</SlideInWrapper>
	)
}

export default LiveChat
